import { ref, watch, onMounted } from 'vue'
import { Network } from '@capacitor/network'
import { App } from '@capacitor/app'
import { wiseToast } from '../WiseEcom/services/WiseToast.js'
import { _locale } from '../WiseEcom/services/WiseLocale.js'
import debounce from './debounce.js'

const networkStatus = ref(null)
let offlineToastShown = false
let networkListener = null
let appStateListenerAdded = false

let appIsActive = true

const debouncedNetworkToast = debounce((connected, lastConnected) => {
	if (!appIsActive) return
	if (!connected) {
		offlineToastShown = true
		wiseToast({
			header: _locale('network.title'),
			message: _locale('network.noConnection'),
			color: 'danger',
			duration: 8000,
		})
	} else if (connected && lastConnected === false && offlineToastShown) {
		offlineToastShown = false
		wiseToast({
			header: _locale('network.title'),
			message: _locale('network.connectionRestored'),
			color: 'success',
			duration: 8000,
		})
	}
}, 3000)

export function useNetworkStatus() {
	onMounted(async () => {
		if (networkListener) return

		networkListener = Network.addListener('networkStatusChange', (status) => {
			networkStatus.value = status
		})
		networkStatus.value = await Network.getStatus()

		if (!appStateListenerAdded) {
			appStateListenerAdded = true
			App.addListener('appStateChange', ({ isActive }) => {
				appIsActive = isActive
				if (isActive) {
					debouncedNetworkToast.cancel()
					Network.getStatus().then(status => {
						networkStatus.value = status
					})
				}
			})
		}
	})

	watch(networkStatus, (val, oldVal) => {
		if (!oldVal) return
		debouncedNetworkToast(val.connected, oldVal.connected)
	})

	return { networkStatus }
}
